import { createParser, system } from '../core';
var config = {
  transform: true,
  transformOrigin: true
};
export var transform = system(config);
export var transformParser = createParser(config);